var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5332 5.33275L9.26654 1.53275C9.5332 1.26608 9.5332 0.866081 9.26654 0.599414C8.99987 0.332747 8.59987 0.332747 8.3332 0.599414L4.99987 3.86608L1.66654 0.599414C1.39987 0.332747 0.99987 0.332747 0.733203 0.599414C0.59987 0.732747 0.533203 0.866081 0.533203 1.06608C0.533203 1.26608 0.59987 1.39941 0.733203 1.53275L4.46654 5.33275C4.79987 5.59941 5.19987 5.59941 5.5332 5.33275C5.46654 5.33275 5.46654 5.33275 5.5332 5.33275Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.78ea3416786a787f482e5311c64867ab.svg";
export { ForwardRef as ReactComponent };